import { useState, useRef } from 'react';
import { motion } from 'framer-motion';

export const HeroVideo = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full bg-white"
      data-testid="home-hero-section"
    >
      {/* Full-width video, no rounded corners, no extra block below */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full overflow-hidden bg-white"
      >
        <video
          ref={videoRef}
          src="/assets/video/intro.mp4"
          autoPlay
          muted
          loop
          playsInline
          poster="/assets/backgrounds/gradient-orange.jpg"
          className="block w-full h-auto object-cover"
          data-testid="hero-logo-video"
        />
        {/* Invisible click-to-toggle overlay (no watermark icon) */}
        <button
          onClick={togglePlay}
          className="absolute inset-0 cursor-pointer"
          aria-label={isPlaying ? 'Pausar video' : 'Reproducir video'}
          data-testid="hero-video-play-button"
        />
      </motion.div>
    </section>
  );
};
